export default {
  setReportTypes: (state, value) => {
    state.reportTypes = value
  },
  setSelectedReportType: (state, value) => {
    state.selectedReportType = value
  },
  setOperators: (state, value) => {
    state.operators = value
  }
}
